import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { Icon } from "@circle-react-shared/Icon";

export const ListViewTicketInfo = ({ ticketData }: any) => (
  <div className="flex items-center gap-x-1.5">
    <Icon type="16-event-ticket" size={16} className="text-default !w-4" />
    <div className="flex items-center justify-center space-x-1">
      <Typography.LabelXs>{ticketData.price_with_code}</Typography.LabelXs>
    </div>
  </div>
);
